export default {
    InternalReturnRefundNoteDetails: {
        Return: 'Return logistics',
        Logistics: 'Logistics Information',
        reviewed: 'Can only be modified when pending review or awaiting return by the buyer',
        warehouse: 'Return warehouse',
        Warehousing: 'Inbound notice',
        Receipt: 'Inbound result',
        Financial: 'Financial information',
        Settlement: 'Settlement method',
        Add: 'Add label',
        Associated: 'Associated documents',
        Internal: 'Internal return Order No.',
        Third: 'Third-party return Order No.',
        order: 'Customer Order No.',
        number: 'CSG Order No.',
        creation: 'Internal Creation Time',
        time: 'Third-party return time',
        receipttime: 'Return received time',
        Completion: 'Completion time',
        Picture: 'Image attachment',
        Upload: 'Upload',
        Product: 'Product Information',
        refund: 'Add return and refund product',
        Select: 'Select products to return and refund',
        Other: 'Others',
        Quantity: 'Shipped quantity:',
        Returned: 'Returned quantity:',
        Returnable: 'Available return quantity:',
        Shipment: 'Delivery status:',
        Preemption: 'Reservation Status:',
        Sourcing: 'Sourcing status:',
        Delete: 'Delete',
    }
};
